export class SecurityAccess {
  userId: string;
  securityCode: string;
}
